import React from 'react'
import OurServices from '../components/OurServices/OurServices'
import Hero2 from '../components/Hero2/Hero2'
import OurServices1 from '../components/OurServices1/OurServices1'
import OurServices2 from '../components/OurServices2/OurServices2'

const Services = () => {
  return (
    <div className="services">
        <OurServices />
        <Hero2/>
        <OurServices1 />
        <OurServices2 />
    </div>
  )
}

export default Services